// File: MSEntraIDLanding.js
import React, { useRef, useState, useEffect } from "react";
import {
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane
} from "mdb-react-ui-kit";

import SsoFormSection from "../../components/microsoft-entraid-integration/settings-ms-sso";
import MSUserProvisioning from "../../components/microsoft-entraid-integration/settings-ms-userprovisioning";

import { useTranslation } from "react-i18next";
import MainLinks from "../../components/navlinks/MainLinks";
import Body from "../../components/body/BodyPage";
import EditWarning from "../../components/header/EditWarning";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import MicroSoftTeam from "./MicroSoftTeam";
import { isFiveNineAccount } from "../Login";

function MSEntraIDLanding() {
    const { t } = useTranslation();

    const [outerTab, setOuterTab] = useState(
        sessionStorage.getItem("outer_tab") || "entra"
    );
    const handleOuterTabClick = (value) => {
        if (outerTab === value) return;

        if (isEdited) {
            setPendingSection(value);
            setShowWarning(true);
            return;
        }

        setOuterTab(value);
        sessionStorage.setItem("outer_tab", value);
    };

    const { isEdited, setEdited } = useAdminContext();
    const [innerSection, setInnerSection] = useState(() => {
        return sessionStorage.getItem("inner_section") || "user";
    });

    const fiveNineacc = isFiveNineAccount();
    const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
    const containerRef = useRef(null);
    const sectionUserRef = useRef(null);
    const sectionSsoRef = useRef(null);
    const [resetKey, setResetKey] = useState(0);


    useEffect(() => {
        sessionStorage.setItem("inner_section", innerSection);

        setTimeout(() => {
            if (innerSection === "user") {
                sectionUserRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
            } else if (innerSection === "sso") {
                sectionSsoRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 60);
    }, [innerSection]);

    const [showWarning, setShowWarning] = useState(false);
    const [pendingSection, setPendingSection] = useState(null);

    const showSaveBar = isEdited;

    const handleLeftNavClick = (target) => {
        if (target === innerSection) return;
        if (isEdited) {
            setPendingSection(target);
            setShowWarning(true);
            return;
        }
        setInnerSection(target);
    };

    const handleWarningOk = () => {
        // reset children completely
        setResetKey(prev => prev + 1);

        setEdited(false);

        if (pendingSection) {
            if (pendingSection === "teams" || pendingSection === "entra") {
                setOuterTab(pendingSection);
                sessionStorage.setItem("outer_tab", pendingSection);
            } else {
                setInnerSection(pendingSection);
                sessionStorage.setItem("inner_section", pendingSection);
            }
            setPendingSection(null);
        }

        setShowWarning(false);
    };



    const handleWarningCancel = () => {
        setPendingSection(null);
        setShowWarning(false);
    };


    const handleSave = () => {
        const resolvedSection =
            innerSection ||
            sessionStorage.getItem("inner_section") ||
            "user";

        window.dispatchEvent(new CustomEvent("entra-save", { detail: { section: resolvedSection } }));
        if (resolvedSection === "user") {
            window.dispatchEvent(new CustomEvent("save-user-provisioning"));
        } else if (resolvedSection === "sso") {
            window.dispatchEvent(new CustomEvent("save-sso"));
        }
        setEdited(false);
    };

    const handleDiscard = () => {
        const ev = new CustomEvent("entra-discard", { detail: { source: "MSEntraIDLanding" } });
        window.dispatchEvent(ev);
        setEdited(false);
    };

    return (
        <>
            <style>{`
        .leftTabs {
          position: sticky;
          top: 20px;
          height: fit-content;
        }
        .leftTabs .scrollspy-link {
          display: block;
          padding: 12px 14px;
          border-radius: 6px;
          margin-bottom: 8px;
          text-align: left;
          cursor: pointer;
          font-weight: bold;
        }
        .leftTabs .scrollspy-link.active {
          position: relative;
          background: var(--mdb-gray-200) !important;
         color: var(--mdb-primary) !important;
        }
        
        .fade-section {
          animation: fadeInUp 300ms ease;
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

            <MainLinks active={6} />

            <Body
                tablinks={6}
                sublink={272}
                content={
                    <>
                        <section className="mb-3">
                            <div className="card card-height">
                                <div className="card-header py-2 px-0">
                                    <h5 className="mb-0">{t("Microsoft Integrations")}</h5>
                                </div>

                                <div className="card-body pe-0">

                                    {/* OUTER TABS */}
                                    <MDBTabs className="mb-4">
                                        <MDBTabsItem>
                                            <MDBTabsLink
                                                onClick={() => handleOuterTabClick("entra")}
                                                active={outerTab === "entra"}
                                            >
                                                {t("Microsoft Entra")}
                                            </MDBTabsLink>
                                        </MDBTabsItem>

                                        <MDBTabsItem>
                                            {!(fiveNineacc || isWholesaleAcc) && (<>
                                                <MDBTabsLink
                                                    onClick={() => handleOuterTabClick("teams")}
                                                    active={outerTab === "teams"}
                                                >
                                                    {t("Microsoft Teams")}
                                                </MDBTabsLink>
                                            </>)}
                                        </MDBTabsItem>
                                    </MDBTabs>

                                    <MDBTabsContent>
                                        <MDBTabsPane open={outerTab === "entra"}>
                                            <div className="d-flex">

                                                {/* LEFT NAV – controlled active state, same visual as other Settings side tabs */}
                                                <div className="me-4 d-flex flex-column leftTabs" style={{ width: "220px" }}>
                                                    <div>
                                                        <div
                                                            role="button"
                                                            tabIndex={0}
                                                            className={
                                                                "scrollspy-link " +
                                                                (innerSection === "user" ? "active" : "")
                                                            }
                                                            onClick={() => handleLeftNavClick("user")}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    handleLeftNavClick("user");
                                                                }
                                                            }}
                                                        >
                                                            {t("UserProvisioning")}
                                                        </div>

                                                        <div
                                                            role="button"
                                                            tabIndex={0}
                                                            className={
                                                                "scrollspy-link " +
                                                                (innerSection === "sso" ? "active" : "")
                                                            }
                                                            onClick={() => handleLeftNavClick("sso")}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    handleLeftNavClick("sso");
                                                                }
                                                            }}
                                                        >
                                                            {t("SingleSignOn")}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* RIGHT CONTENT */}

                                                <div className="flex-grow-1 leftTabContent vtabHeigh">
                                                    <div
                                                        ref={containerRef}
                                                        className="scrollspy-example micro-entrascroll" >

                                                        {/* SHOW ONLY USER PROVISIONING */}
                                                        {innerSection === "user" && (
                                                            <section
                                                                ref={sectionUserRef}
                                                                id="section-user"
                                                                className="fade-section"
                                                                style={{ paddingTop: 18 }}
                                                            >
                                                                <h5 className="fw-bold">{t("UserProvisioning")}</h5>

                                                                <div style={{ marginTop: 14 }}>
                                                                    <MSUserProvisioning
                                                                        setEdited={setEdited}
                                                                        active={true}
                                                                        resetKey={resetKey}
                                                                    />
                                                                </div>
                                                            </section>
                                                        )}

                                                        {/* SHOW ONLY SSO */}
                                                        {innerSection === "sso" && (
                                                            <section
                                                                ref={sectionSsoRef}
                                                                id="section-sso"
                                                                className="fade-section"
                                                                style={{ paddingTop: 18 }}
                                                            >
                                                                <h5 className="fw-bold">{t("SingleSignOn")}</h5>

                                                                <div style={{ marginTop: 14 }}>
                                                                    <SsoFormSection
                                                                        setEdited={setEdited}
                                                                        active={true}
                                                                        resetKey={resetKey}
                                                                    />
                                                                </div>
                                                            </section>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </MDBTabsPane>

                                        {/* TEAMS TAB */}
                                        {!(fiveNineacc || isWholesaleAcc) && (<>
                                            <MDBTabsPane open={outerTab === "teams"}>
                                                <MicroSoftTeam
                                                    isActive={outerTab === "teams"}
                                                    setEdited={setEdited}
                                                />
                                            </MDBTabsPane>
                                        </>)}
                                    </MDBTabsContent>

                                </div>
                            </div>
                        </section>

                        {/* Edit Warning Popup */}
                        {showWarning && (
                            <EditWarning
                                warningToggle={() => setShowWarning(false)}
                                setShowWarning={setShowWarning}
                                onOk={handleWarningOk}
                                onCancel={handleWarningCancel}
                            />
                        )}

                        {/* Example Save/Discard UI you might be using elsewhere: */}
                        {/* If you have a floating Save bar that calls handleSave/handleDiscard, wire it to these handlers */}
                        {/* {showSaveBar && (
              <div className="fixed-bottom p-3" style={{ pointerEvents: "auto" }}>
                <div className="d-flex justify-content-end gap-2">
                  <button className="btn btn-outline-secondary" onClick={handleDiscard}>Discard</button>
                  <button className="btn btn-primary" onClick={handleSave}>Save changes</button>
                </div>
              </div>
            )} */}

                    </>
                }
            />
        </>
    );
}

export default MSEntraIDLanding;
